import { Box, Button, TextField, Typography } from '@mui/material';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ACTIVE_YEAR_MD, LAST_ACTIVE_YEAR_CHANGE } from 'constants/fields';
import { updateMetadata } from 'store/actions';
import { selectMetadata, selectToken } from 'store/selectors';

import { buttonStyle } from './YearSelector.style';

const YearSelector = () => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const md = useSelector(selectMetadata);

  const [formData, setFormData] = React.useState({});
  const [formValid, setFormValid] = React.useState(false);

  const checkForm = () => {
    if (formData.active_year) {
      setFormValid(true);
    } else {
      setFormValid(false);
    }
  };

  const updateData = (value, key) => {
    let update = formData;
    update[key] = value;

    setFormData(update);
    checkForm();
  };

  const updateActiveYear = () => {
    updateData(null, LAST_ACTIVE_YEAR_CHANGE);
    dispatch(updateMetadata(formData, token));
    setFormData({});
    setFormValid(false);
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
      <Typography variant="h5">Change Active Year</Typography>
      <Typography variant="subtitle2" color="text.secondary">
        Last changed: {md.last_active_year_change ?? 'N/A'}
      </Typography>
      <Typography variant="subtitle1" flexGrow={1}>
        Current active year: {md.year}
      </Typography>
      <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
        <TextField
          onChange={(event) => {
            updateData(event.target.value, ACTIVE_YEAR_MD);
          }}
          margin="dense"
          id="active_year"
          size="small"
          label="New active year"
        />
        <Button
          variant="contained"
          onClick={updateActiveYear}
          sx={buttonStyle}
          disabled={!formValid}>
          Change
        </Button>
      </Box>
    </Box>
  );
};

export default YearSelector;
